import { useMemo } from 'react';
import { ImageAsset, ImageUrls } from 'src/common/interfaces/image-asset.interface';
import { SrcSetDefinition, stringifySrcset } from 'srcset';

type Size = 'thumbnail_300x300' | 'preview_1920x1080';

function pushToSrcSetIfExists(imageUrls: ImageUrls, srcset: SrcSetDefinition[], key: keyof ImageUrls, density: number) {
  if (imageUrls[key]) {
    srcset.push({
      url: imageUrls[key],
      density,
    });
  }
}

export const getImageAssetSrcSet = (imageAsset?: ImageAsset, size?: Size): string => {
  if (!imageAsset?.image_urls) {
    return '';
  }
  const srcset: SrcSetDefinition[] = [];
  if (size === 'thumbnail_300x300') {
    pushToSrcSetIfExists(imageAsset.image_urls, srcset, '300x300', 1);
    pushToSrcSetIfExists(imageAsset.image_urls, srcset, '300x300x2', 2);
  }
  if (size === 'preview_1920x1080') {
    pushToSrcSetIfExists(imageAsset.image_urls, srcset, '1920x1080', 1);
    pushToSrcSetIfExists(imageAsset.image_urls, srcset, '1920x1080x2', 2);
  }
  if (srcset.length === 0) {
    return '';
  }
  return stringifySrcset(srcset);
};

export const useImageAssetSrcSet = (imageAsset?: ImageAsset, size?: Size): string =>
  useMemo(() => getImageAssetSrcSet(imageAsset, size), [imageAsset, size]);
